<template>
  <div class="static-table">
    <!-- 约定：selection/index/toolbar 为前端展示列；后端仅在覆盖 columns 时做兜底回并 -->
    <el-table class="table" ref="multipleTable" highlight-current-row border :data="tableQuery.data" :select="tableSelects"
      size="small" @sort-change="onSortChange" @current-change="onCurrentChange" @select="onSelect"
      @selection-change="onSelectionChange" @filter-change="permissionFilterChange" @header-dragend="onColumnResize">
      <template v-for="(col, index) in tableQuery.columns" :key="getColumnIdentity(col, index)" :prop="col.prop" :label="col.label">
        <el-table-column v-if="(col.type || '') === 'selection'" type="selection" :width="col.width || 55"
          align="center" />

        <el-table-column v-else-if="(col.type || '') === 'index'" :label="col.label" width="50" align="center">
          <template #default="scope">
            <span>{{ scope.$index + (tableQuery.page - 1) * tableQuery.rows + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column v-else-if="(col.type || '') === 'template'" :prop="col.prop" :label="col.label"
          :column-key="getColumnKey(col, index)"
          :align="col.align || 'center'" :sortable="col.sortable" :width="col.width || 0"
          :fixed="col.fixed || false"
          :show-overflow-tooltip="col.showOverflowTooltip || false"
          :filters="col.permission != null && col.permission !== 0 ? permissionFilters : undefined"
          :filter-multiple="col.permission != null && col.permission !== 0 ? false : undefined"
          :filter-method="col.permission != null && col.permission !== 0 ? (() => true) : null">
          <template #default="scope">
            <slot :name="col.prop" :row="scope.row"></slot>
          </template>
        </el-table-column>
        
        <el-table-column v-else-if="(col.type || '') === 'toolbar'" :label="col.label"
          :column-key="getColumnKey(col, index)"
          :width="col.width || 0"
          fixed="right" align="center">
          <template #default="scope">
            <slot name="toolbar" :row="scope.row" :id="scope.row.id"></slot>
          </template>
        </el-table-column>

        <template v-else-if="(col.type || '') === 'hidden'" :sortable="col.sortable" :width="0">
        </template>

        <el-table-column v-else="(col.type || '') === ''" :prop="col.prop" :label="col.label" :sortable="col.sortable"
          :column-key="getColumnKey(col, index)"
          :width="col.width || 0" :align="col.align || 'left'"
          :fixed="col.fixed || false"
          :show-overflow-tooltip="col.showOverflowTooltip || false"
          :filters="col.permission != null && col.permission !== 0 ? permissionFilters : undefined"
          :filter-multiple="col.permission != null && col.permission !== 0 ? false : undefined"
          :filter-method="col.permission != null && col.permission !== 0 ? (() => true) : null">
        </el-table-column>
      </template>
    </el-table>
    <el-pagination class="pagination" :currentPage="tableQuery.page" :page-size="tableQuery.rows || tableQuery.size || 10"
      :page-sizes="[10, 20, 50, 100, 200, 500]" layout="total, sizes, prev, pager, next, jumper"
      :total="tableQuery.records || 0" background @size-change="pageSizeHandler" @current-change="pageChangHandler" />
  </div>
</template>
<script>
export default {
  components: {},
  name: "BasicTable",
  props: {
    query: { type: Object, required: false },
    selects: { type: Object, required: false },
    // legacy props (for pages migrated from static-table)
    pager: { type: Object, required: false },
    columns: { type: Array, required: false },
    checkedRows: { type: Object, required: false },
    currHandler: { type: Function, required: false },
    seleHandler: { type: Function, required: false },
    sortHandler: { type: Function, required: false },
    pageHandler: { type: Function, required: false },
    sizeHandler: { type: Function, required: false },
    selectHandler: { type: Function, required: false },
    filterHandler: { type: Function, required: false },
  },
  emits: ["handler"],
  computed: {
    tableQuery() {
      if (this.query) return this.query;
      const legacyQuery = this.pager || {};
      if (Array.isArray(this.columns)) legacyQuery.columns = this.columns;
      if (!Array.isArray(legacyQuery.columns)) legacyQuery.columns = [];
      if (!Array.isArray(legacyQuery.data)) legacyQuery.data = [];
      if (!legacyQuery.page) legacyQuery.page = 1;
      if (!legacyQuery.rows && !legacyQuery.size) legacyQuery.rows = 10;
      if (typeof legacyQuery.records === 'undefined' || legacyQuery.records === null) legacyQuery.records = 0;
      return legacyQuery;
    },
    tableSelects() {
      return this.selects || this.checkedRows || [];
    },
  },
  data() {
      return {
        //pager: { page: 1, rows: 10, records: 0 }
        chooseRow: null,
        selectIds: [],   //当页勾选的数据
        dragSourceIndex: -1, // 当前拖拽源列索引
        permissionFilters: [
          { text: '明文展示', value: '1' },
          { text: '部分脱敏', value: '2' },
          { text: '全部脱敏', value: '3' },
        ],
      };
  },
  methods: {
    // 判断列是否允许参与拖拽重排（隐藏列、操作列、固定列不可拖拽）
    isDraggableColumn(col) {
      const type = (col?.type || '');
      return type !== 'hidden' && type !== 'toolbar' && !col?.fixed;
    },
    // 生成列身份 key，避免同名列在 v-for 中复用异常
    getColumnIdentity(col, index) {
      if (col?.prop) return `prop:${col.prop}:${col?.type || ''}:${index}`;
      return `meta:${col?.type || ''}:${col?.label || ''}:${index}`;
    },
    // 生成列筛选/排序使用的稳定 column-key
    getColumnKey(col, index) {
      return `${col?.prop || ''}:${col?.type || ''}:${index}`;
    },
    // 返回当前可拖拽列集合
    getDraggableColumns() {
      if (!Array.isArray(this.tableQuery.columns)) return [];
      return this.tableQuery.columns.filter(col => this.isDraggableColumn(col));
    },
    // 获取主表头单元格并排除 gutter，优先匹配期望列数
    getHeaderCells(expectedCount = 0) {
      const tableEl = this.$refs.multipleTable?.$el;
      if (!tableEl) return [];
      const wrappers = Array.from(tableEl.querySelectorAll('.el-table__header-wrapper'));
      if (!wrappers.length) return [];

      let bestCells = [];
      let exactMatched = false;
      wrappers.forEach(wrapper => {
        const cells = Array.from(wrapper.querySelectorAll('thead tr th'))
          .filter(th => !th.classList.contains('gutter'));
        if (!exactMatched && expectedCount > 0 && cells.length === expectedCount) {
          bestCells = cells;
          exactMatched = true;
          return;
        }
        if (!exactMatched && cells.length > bestCells.length) bestCells = cells;
      });
      return bestCells;
    },
    // 绑定表头拖拽事件（已绑定的单元格不会重复绑定）
    bindHeaderDrag() {
      const draggableColumns = this.getDraggableColumns();
      const cells = this.getHeaderCells(draggableColumns.length);
      cells.forEach((cell, index) => {
        if (!draggableColumns[index]) return;
        cell.dataset.columnIndex = String(index);
        if (cell.dataset.dragBound === '1') return;
        cell.setAttribute('draggable', 'true');
        cell.style.cursor = 'move';
        cell.addEventListener('dragstart', this.handleHeaderDragStart);
        cell.addEventListener('dragover', this.handleHeaderDragOver);
        cell.addEventListener('drop', this.handleHeaderDrop);
        cell.addEventListener('dragend', this.handleHeaderDragEnd);
        cell.dataset.dragBound = '1';
      });
    },
    // 拖拽开始：记录源列索引并写入 dataTransfer
    handleHeaderDragStart(event) {
      const index = Number(event.currentTarget?.dataset?.columnIndex);
      if (Number.isNaN(index)) return;
      this.dragSourceIndex = index;
      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('text/plain', String(index));
      }
    },
    // 拖拽经过：允许 drop 并设置视觉反馈
    handleHeaderDragOver(event) {
      event.preventDefault();
      if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    },
    // 拖拽落点后重排列顺序，仅调整可拖拽列并触发查询
    handleHeaderDrop(event) {
      event.preventDefault();
      const targetIndex = Number(event.currentTarget?.dataset?.columnIndex);
      const sourceIndex = this.dragSourceIndex;
      this.dragSourceIndex = -1;
      if (Number.isNaN(sourceIndex) || Number.isNaN(targetIndex) || sourceIndex === targetIndex) return;
      if (!Array.isArray(this.tableQuery.columns)) return;

      const source = this.tableQuery.columns;
      const draggable = source.filter(col => this.isDraggableColumn(col));
      if (sourceIndex < 0 || targetIndex < 0 || sourceIndex >= draggable.length || targetIndex >= draggable.length) return;

      const moved = draggable.splice(sourceIndex, 1)[0];
      draggable.splice(targetIndex, 0, moved);

      let draggableCursor = 0;
      const reordered = source.map(col => (this.isDraggableColumn(col) ? draggable[draggableCursor++] : col));
      this.tableQuery.columns.splice(0, this.tableQuery.columns.length, ...reordered);
      this.tableQuery.page = 1;
      this.tableQuery.layoutChanged = true;
      this.emitHandlerByMode('filter');
      this.$nextTick(() => this.bindHeaderDrag());
    },
    // 拖拽结束：重置拖拽状态
    handleHeaderDragEnd() {
      this.dragSourceIndex = -1;
    },
    // 列宽拖拽后同步到 query.columns，并触发持久化/刷新
    onColumnResize(newWidth, oldWidth, column) {
      if (!Array.isArray(this.tableQuery.columns)) return;
      const width = Math.round(Number(newWidth));
      if (!Number.isFinite(width) || width <= 0) return;

      const prop = column?.property || column?.columnKey;
      let targetColumn = null;
      if (column?.columnKey) {
        targetColumn = this.tableQuery.columns.find((col, index) => this.getColumnKey(col, index) === column.columnKey);
      }
      if (!targetColumn && prop) {
        targetColumn = this.tableQuery.columns.find(col => col?.prop === prop);
      }
      if (!targetColumn && column?.label) {
        targetColumn = this.tableQuery.columns.find(col => col?.label === column.label);
      }
      if (!targetColumn) return;

      const normalizedWidth = String(width);
      if (String(targetColumn.width) === normalizedWidth) return;
      targetColumn.width = normalizedWidth;
      this.tableQuery.page = 1;
      this.tableQuery.layoutChanged = true;
      this.emitHandlerByMode('filter');
    },
    // 权限筛选变更：将筛选值写回列 permission 并触发查询
    permissionFilterChange(filters) {
      if (!Array.isArray(this.tableQuery.columns)) return;
      let changed = false;
      this.tableQuery.columns.forEach((col, index) => {
        if (col.permission == null || col.permission === 0 || !col.prop) return;
        const selected = filters?.[this.getColumnKey(col, index)] ?? filters?.[col.prop];
        if (!Array.isArray(selected) || selected.length === 0) return;
        const permission = Number(selected[0]);
        if (Number.isNaN(permission) || col.permission === permission) return;
        col.permission = permission;
        changed = true;
      });
      if (changed) {
        this.tableQuery.page = 1;
        this.tableQuery.layoutChanged = true;
        this.emitHandlerByMode('filter');
      }
    },
    // 统一处理 query 模式与 legacy 回调模式的事件派发
    emitHandlerByMode(kind, payload) {
      if (this.query) {
        this.$emit('handler', this.tableQuery);
        this.tableQuery.layoutChanged = false;
        return;
      }
      if (kind === 'sort' && typeof this.sortHandler === 'function') {
        this.sortHandler(payload);
        return;
      }
      if (kind === 'size' && typeof this.sizeHandler === 'function') {
        this.sizeHandler(payload);
        return;
      }
      if (kind === 'page' && typeof this.pageHandler === 'function') {
        this.pageHandler(payload);
        return;
      }
      if (kind === 'filter') {
        if (typeof this.filterHandler === 'function') {
          this.filterHandler(this.tableQuery, this.tableQuery.columns);
          return;
        }
        if (typeof this.pageHandler === 'function') {
          this.pageHandler(this.tableQuery.page || 1);
        }
      }
    },
    // 排序变更
    onSortChange: function (order) {
      this.tableQuery.sidx = order.prop;
      this.tableQuery.sord = order.order;
      this.emitHandlerByMode('sort', order);
    },
    // 分页大小变更
    pageSizeHandler: function (rows) {
      this.tableQuery.rows = rows;
      this.emitHandlerByMode('size', rows);
    },
    // 页码变更
    pageChangHandler: function (page) {
      this.tableQuery.page = page;
      this.emitHandlerByMode('page', page);
    },

    // 当前行变更
    onCurrentChange: function (row) {
      //console.log('currentHandler', row);
      this.chooseRow = row;
      this.tableQuery.current = row;
      if (typeof this.currHandler === 'function') this.currHandler(row);
      //this.$emit('currentHandler', this.query);
    },
    // 将“当前页勾选状态”合并到“全局勾选ID集合”
    processSelectionRows(rows) {  //勾选发生变动的时候
      //if(!this.selectIds) return;
      //console.log('selectHandler this.selectRows', this.selectRows);
      //console.log('selectHandler all rows',this.$refs.multipleTable.data);
      //console.log('selectHandler start', this.selectRows);

      //this.selectRows = rows;
      //console.log('selectHandler rows', rows)

      //先循环当前页面行数据(不管有没有选中)
      let pageRows = this.$refs.multipleTable.data;
      pageRows.forEach(item => {
        let checked = rows.indexOf(item) >= 0; //是否勾选了该行
        let existed = this.selectIds.indexOf(item.id) >= 0; //勾选总数据中是否已存在

        //console.log('selectHandler name rows',item.realName, rows);

        //如果勾选上了该行，且总勾选中不存在就添加
        if (checked && !existed) {
          this.selectIds.push(item.id);
        }

        //如果取消勾选了该行，且总勾选中存在就删除
        if (!checked && existed) {
          this.selectIds = this.selectIds.filter(q => q != item.id);
        }
      });
      //console.log('selectHandler result', this.selectIds);

      //通过当前行的数据，对比勾选上的数据，得到未勾选的数据。去更新整个数据
      //this.selectRows = rows;
      //this.query.selects = rows;
      //this.$emit('handler', this.query);
    },
    // 单行勾选事件
    onSelect(selection, row) {
      if (typeof this.selectHandler === 'function') this.selectHandler(selection, row);
      this.processSelectionRows(selection);
    },
    // 勾选集合变更事件
    onSelectionChange(rows) {
      this.processSelectionRows(rows);
      if (typeof this.seleHandler === 'function') this.seleHandler(rows);
    },
  },
  mounted() {
    // 组件初始化：绑定表头拖拽
    this.$nextTick(() => this.bindHeaderDrag());
  },
  watch: {
    tableQuery: {
      // 表格数据/列变化后，回填跨页勾选并重新绑定拖拽
      handler(newValue, oldValue) {
      //console.log('basic-table-watch oldValue.newValue', oldValue,newValue);
      let that = this;
      // if (newValue && newValue.selects)
      //   setTimeout(() => {
      //     newValue.selects.forEach(item => {
      //       console.log('that.$refs.multipleTable',that.$refs.multipleTable);
      //       that.$refs.multipleTable.toggleRowSelection(item);
      //     })
      //   });

      //console.log('init selects', this.selectRows)

      //如果设置了selects表示需要对checkedRows进行设置  
      //oldValue && !oldValue.selects &&
      if (this.selectIds) {
        this.selectIds.forEach(item => { // checkedData为已选数据
          this.$nextTick(() => {
            this.tableQuery.data.find(obj => { // userData 表单数据
              if (item === obj.id) {
                this.$refs.multipleTable.toggleRowSelection(obj, true)
                //console.log('toggleRowSelection', obj.realName);
              }
            })
          })
        })
      }
      this.$nextTick(() => this.bindHeaderDrag());
      },
      deep: true,
    },
    // 外部勾选数据变化时同步到本地 selectIds
    tableSelects: function (newValue, oldValue) {
      //console.log('basic-table-selects oldValue.newValue.selectIds', oldValue, newValue, this.selectIds);
      this.selectIds = newValue || [];
    }
  }
};
</script>
<style scoped></style>
